module.exports = __webpack_public_path__ + "static/media/aeronave.3ddafab8.glb";